import './AnalyticsView.scss';

export { default } from './AnalyticsView';
